let templates = {
	de: {
		async doz() {
			const templateLoader = () => import("@/assets/js/templates_de/doz.js");
			const template = await templateLoader();
			return template.default;
		},
		async bsp() {
			const templateLoader = () => import("@/assets/js/templates_de/bsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async bsp_matwis() {
			const templateLoader = () => import("@/assets/js/templates_de/bsp_matwis.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_career() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_career.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_ueb_spr() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_ueb_spr.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_ueb_spr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_ueb_spr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async angl_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/angl_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ashd() {
			const templateLoader = () => import("@/assets/js/templates_de/ashd.js");
			const template = await templateLoader();
			return template.default;
		},
		async ashd_k() {
			const templateLoader = () => import("@/assets/js/templates_de/ashd_k.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_e() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_e.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_e_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_e_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_p_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_p_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_p_or() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_p_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_p_or_k() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_p_or_k.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_p_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_p_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_p_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_p_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl_k() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl_k.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bio_vl_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/bio_vl_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_baumeister_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_baumeister_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_baumeister_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_baumeister_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_baumeister_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_baumeister_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_baumeister_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_baumeister_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_dietrich_sb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_dietrich_sb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_dietrich_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_dietrich_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_dietrich_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_dietrich_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_dimitrov_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_dimitrov_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_dimitrov_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_dimitrov_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_heidenreich_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_heidenreich_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_heidenreich_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_heidenreich_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_heidenreich_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_heidenreich_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_heidenreich_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_heidenreich_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_kaul_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_kaul_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_kaul_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_kaul_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_knobloch_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_knobloch_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_knobloch_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_knobloch_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_maass_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_maass_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_maass_vl_off() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_maass_vl_off.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_maass_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_maass_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_maass_vl_capstone() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_maass_vl_capstone.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_morana() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_morana.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_stat_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_stat_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_stat_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_stat_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_stat_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_stat_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_stat_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_stat_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_strohmeier_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_strohmeier_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_strohmeier_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_strohmeier_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async bwl_phd() {
			const templateLoader = () => import("@/assets/js/templates_de/bwl_phd.js");
			const template = await templateLoader();
			return template.default;
		},
		async cec() {
			const templateLoader = () => import("@/assets/js/templates_de/cec.js");
			const template = await templateLoader();
			return template.default;
		},
		async cec_modul() {
			const templateLoader = () => import("@/assets/js/templates_de/cec_modul.js");
			const template = await templateLoader();
			return template.default;
		},
		async ceus() {
			const templateLoader = () => import("@/assets/js/templates_de/ceus.js");
			const template = await templateLoader();
			return template.default;
		},
		async ceus_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ceus_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_fd_p() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_fd_p.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_fd_p_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_fd_p_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_fd_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_fd_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_fd_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_fd_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_p() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_p.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_p_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_p_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_p_m() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_p_m.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async ch_vl_m() {
			const templateLoader = () => import("@/assets/js/templates_de/ch_vl_m.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_vl_t() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_vl_t.js");
			const template = await templateLoader();
			return template.default;
		},
		async coli_vl_t_on() {
			const templateLoader = () => import("@/assets/js/templates_de/coli_vl_t_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_s() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_s.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ueb_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ueb_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ueb_dsp_on() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ueb_dsp_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ueb_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ueb_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ws() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ws.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ws_on() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ws_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async dfki_ws_g() {
			const templateLoader = () => import("@/assets/js/templates_de/dfki_ws_g.js");
			const template = await templateLoader();
			return template.default;
		},
		async edutech_s() {
			const templateLoader = () => import("@/assets/js/templates_de/edutech_s.js");
			const template = await templateLoader();
			return template.default;
		},
		async edutech_s_on() {
			const templateLoader = () => import("@/assets/js/templates_de/edutech_s_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async edutech_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/edutech_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async edutech_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/edutech_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_p() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_p.js");
			const template = await templateLoader();
			return template.default;
		}, //benötigt anpassung
		async ezw_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_vl_m() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_vl_m.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_wb_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_wb_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async ezw_wb_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/ezw_wb_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_p() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_p.js");
			const template = await templateLoader();
			return template.default;
		}, //benötigt anpassung
		async fd_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async fd_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/fd_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_e() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_e.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async geo_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/geo_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_ps_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_ps_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_ps_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_ps_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_ps_or() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_ps_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_ps_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_ps_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async ger_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ger_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async globalclass() {
			const templateLoader = () => import("@/assets/js/templates_de/globalclass.js");
			const template = await templateLoader();
			return template.default;
		},
		async gpp() {
			const templateLoader = () => import("@/assets/js/templates_de/gpp.js");
			const template = await templateLoader();
			return template.default;
		},
		async gradus() {
			const templateLoader = () => import("@/assets/js/templates_de/gradus.js");
			const template = await templateLoader();
			return template.default;
		},
		async gradus_g() {
			const templateLoader = () => import("@/assets/js/templates_de/gradus_g.js");
			const template = await templateLoader();
			return template.default;
		},
		async gradusaar() {
			const templateLoader = () => import("@/assets/js/templates_de/gradusaar.js");
			const template = await templateLoader();
			return template.default;
		},
		async hok_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/hok_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async hok_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/hok_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async hok_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/hok_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async hok_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/hok_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async hok_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/hok_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_mp() {
			const templateLoader = () => import("@/assets/js/templates_de/info_mp.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_mv() {
			const templateLoader = () => import("@/assets/js/templates_de/info_mv.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_mv_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/info_mv_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_p() {
			const templateLoader = () => import("@/assets/js/templates_de/info_p.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_p_on() {
			const templateLoader = () => import("@/assets/js/templates_de/info_p_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_ps() {
			const templateLoader = () => import("@/assets/js/templates_de/info_ps.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_s() {
			const templateLoader = () => import("@/assets/js/templates_de/info_s.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_s_on() {
			const templateLoader = () => import("@/assets/js/templates_de/info_s_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_t() {
			const templateLoader = () => import("@/assets/js/templates_de/info_t.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_t_on() {
			const templateLoader = () => import("@/assets/js/templates_de/info_t_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/info_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async info_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/info_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ing_p() {
			const templateLoader = () => import("@/assets/js/templates_de/ing_p.js");
			const template = await templateLoader();
			return template.default;
		},
		async ing_p_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ing_p_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async ing_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/ing_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async ing_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/ing_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async isz() {
			const templateLoader = () => import("@/assets/js/templates_de/isz.js");
			const template = await templateLoader();
			return template.default;
		},
		async isz_on() {
			const templateLoader = () => import("@/assets/js/templates_de/isz_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async jura_beckmann() {
			const templateLoader = () => import("@/assets/js/templates_de/jura_beckmann.js");
			const template = await templateLoader();
			return template.default;
		},
		async jura_coach() {
			const templateLoader = () => import("@/assets/js/templates_de/jura_coach.js");
			const template = await templateLoader();
			return template.default;
		},
		async jura_t() {
			const templateLoader = () => import("@/assets/js/templates_de/jura_t.js");
			const template = await templateLoader();
			return template.default;
		},
		async jura_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/jura_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async jura_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/jura_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async klipsy_fs() {
			const templateLoader = () => import("@/assets/js/templates_de/klipsy_fs.js");
			const template = await templateLoader();
			return template.default;
		},
		async klipsy_fs_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/klipsy_fs_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async mathe_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/mathe_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async mathe_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/mathe_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async mathe_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/mathe_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async mathe_t() {
			const templateLoader = () => import("@/assets/js/templates_de/mathe_t.js");
			const template = await templateLoader();
			return template.default;
		},
		async mathe_t_on() {
			const templateLoader = () => import("@/assets/js/templates_de/mathe_t_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_p42() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_p42.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_tut() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_tut.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_vl_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_vl_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_vl_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_vl_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async matwis_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/matwis_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_ag_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_ag_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_mr_ag_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_mr_ag_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_or() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_p_or_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_p_or_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_ag_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_ag_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_mr_ag_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_mr_ag_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_s_or_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_s_or_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl_alt() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl_alt.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl_alt_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl_alt_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_vl_on_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_vl_on_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_pj() {
			const templateLoader = () => import("@/assets/js/templates_de/med_pj.js");
			const template = await templateLoader();
			return template.default;
		},
		async med_pj_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/med_pj_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async optio_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/optio_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_p_mr_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_p_mr_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_p_mr_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_p_mr_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_p_or_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_p_or_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_p_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_p_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_s_mr_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_s_mr_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_s_mr_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_s_mr_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_s_or_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_s_or_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_s_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_s_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_t_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_t_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_t_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_t_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_vl_usp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_vl_usp.js");
			const template = await templateLoader();
			return template.default;
		},
		async pharm_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/pharm_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async philo() {
			const templateLoader = () => import("@/assets/js/templates_de/philo.js");
			const template = await templateLoader();
			return template.default;
		},
		async philo_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/philo_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async philo_on() {
			const templateLoader = () => import("@/assets/js/templates_de/philo_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_gofex() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_gofex.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_gofex_on() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_gofex_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_p() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_p.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_p_on() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_p_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_ueb_t() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_ueb_t.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_ueb_t_on() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_ueb_t_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async phys_vl_s() {
			const templateLoader = () => import("@/assets/js/templates_de/phys_vl_s.js");
			const template = await templateLoader();
			return template.default;
		},
		async prowis() {
			const templateLoader = () => import("@/assets/js/templates_de/prowis.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_e() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_e.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_e_on() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_e_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async psy_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/psy_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_ueb() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_ueb.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_ueb_on() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_ueb_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async rom_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/rom_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async semstart() {
			const templateLoader = () => import("@/assets/js/templates_de/semstart.js");
			const template = await templateLoader();
			return template.default;
		},
		async semstart_on() {
			const templateLoader = () => import("@/assets/js/templates_de/semstart_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async servicelearning() {
			const templateLoader = () => import("@/assets/js/templates_de/servicelearning.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_ag_note() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_ag_note.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr_ag() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr_ag.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr_ag_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr_ag_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_mr_ag_on() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_mr_ag_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_s_or_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_s_or_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_vl_od() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_vl_od.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_vl_on() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_vl_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async sonst_vl_dsp() {
			const templateLoader = () => import("@/assets/js/templates_de/sonst_vl_dsp.js");
			const template = await templateLoader();
			return template.default;
		},
		async sport() {
			const templateLoader = () => import("@/assets/js/templates_de/sport.js");
			const template = await templateLoader();
			return template.default;
		},
		async sport_summerschool() {
			const templateLoader = () => import("@/assets/js/templates_de/sport_summerschool.js");
			const template = await templateLoader();
			return template.default;
		},
		async sz() {
			const templateLoader = () => import("@/assets/js/templates_de/sz.js");
			const template = await templateLoader();
			return template.default;
		},
		async theo_s_mr() {
			const templateLoader = () => import("@/assets/js/templates_de/theo_s_mr.js");
			const template = await templateLoader();
			return template.default;
		},
		async theo_s_mr_on() {
			const templateLoader = () => import("@/assets/js/templates_de/theo_s_mr_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async theo_s_or() {
			const templateLoader = () => import("@/assets/js/templates_de/theo_s_or.js");
			const template = await templateLoader();
			return template.default;
		},
		async theo_s_or_on() {
			const templateLoader = () => import("@/assets/js/templates_de/theo_s_or_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async theo_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/theo_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async traum_s() {
			const templateLoader = () => import("@/assets/js/templates_de/traum_s.js");
			const template = await templateLoader();
			return template.default;
		},
		async traum_vl() {
			const templateLoader = () => import("@/assets/js/templates_de/traum_vl.js");
			const template = await templateLoader();
			return template.default;
		},
		async zell() {
			const templateLoader = () => import("@/assets/js/templates_de/zell.js");
			const template = await templateLoader();
			return template.default;
		},
		async zell_on() {
			const templateLoader = () => import("@/assets/js/templates_de/zell_on.js");
			const template = await templateLoader();
			return template.default;
		},
		async zesh() {
			const templateLoader = () => import("@/assets/js/templates_de/zesh.js");
			const template = await templateLoader();
			return template.default;
		},
		async zesh_on() {
			const templateLoader = () => import("@/assets/js/templates_de/zesh_on.js");
			const template = await templateLoader();
			return template.default;
		},
	},
};

export default templates;
